import React from "react";
import { Button } from 'react-admin';
import ExportIcon from '@material-ui/icons/GetApp';


export const DownloadButton = ({ buttonLabel, record, variant="outlined", color="primary" }) => {

	return (
      <Button
        label={buttonLabel}
        variant={variant}
        color={color}
        href={record.preview_src}
        redirect={true}
        startIcon={<ExportIcon/>} 
      />
    );
  };
  